export class ClientReleaseInfo {
    public sourceHash!: string;
    public sourceDate!: string;
}
